<template>
  <div v-if="!demoSite">
    <div class="riskmonitoring" v-if="isloadingrisk">
      <div class="risktoptitle">
        <span class="risktoptitle-left">
          <span class="left-title">{{ $t("home.riskMonitoring.title") }}</span>
          <span class="left-info">{{
            $t("home.riskMonitoring.subtitle")
          }}</span>
        </span>
        <span class="risktoptitle-right" @click="golargescreen">
          <span>{{ $t("home.riskMonitoring.viewMore") }}</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.375 12.25L9.625 7L4.375 1.75"
              stroke="#87909F"
              stroke-width="1.2"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </div>
      <div class="riskcontent">
        <div class="riskbox" v-for="(item, index) in riskDatalist" :key="index">
          <p>{{ item.type }}</p>
          <div>
            <span>{{
              $t("home.riskMonitoring.statistics.associatedAddresses")
            }}</span
            ><span>{{ item.associatedAddressNumber }}</span>
          </div>
          <div>
            <span>{{
              $t("home.riskMonitoring.statistics.totalTransactions")
            }}</span
            ><span>{{ item.totalQuantity }}</span>
          </div>
          <div>
            <span>{{ $t("home.riskMonitoring.statistics.totalAmount") }}</span
            ><span>{{ item.totalAmount }} {{ item.currencySymbol }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-skeleton v-else animated class="riskmonitoringloading">
      <template slot="template">
        <div class="risktoptitle">
          <span class="risktoptitle-left">
            <span class="left-title">{{
              $t("home.riskMonitoring.title")
            }}</span>
            <span class="left-info">{{
              $t("home.riskMonitoring.subtitle")
            }}</span>
          </span>
          <span class="risktoptitle-right">
            <span>{{ $t("home.riskMonitoring.viewMore") }}</span>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.375 12.25L9.625 7L4.375 1.75"
                stroke="#87909F"
                stroke-width="1.2"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>

        <div class="riskcontent">
          <div
            v-for="(item, index) in loadingArray"
            :key="index"
            class="riskbox"
            style="background: #0f1721"
          >
            <el-skeleton-item
              variant="p"
              style="background: #1c2634; width: 150px; height: 34px"
            />
            <div
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 95px; height: 22px"
              />
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 180px; height: 22px"
              />
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 95px; height: 22px"
              />
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 180px; height: 22px"
              />
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 95px; height: 22px"
              />
              <el-skeleton-item
                variant="text"
                style="background: #1c2634; width: 180px; height: 22px"
              />
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>

<script>
export default {
  name: "RiskMonitoring",
  props: {
    isloadingrisk: Boolean,
    riskDatalist: Array,
    loadingArray: Array,
  },
  data() {
    return {
      demoSite: true,
    };
  },
  async created() {
    await this.waitForSiteConfig();
    // this.demoSite = this.getConfigValue("demoSite");
  },
  mounted() {
    console.log("RiskMonitoring mounted");

    setTimeout(() => {
      this.demoSite = this.getConfigValue("demoSite");
    }, 1000);
  },

  watch: {
    // 监听语言变化，强制更新组件
    "$i18n.locale"() {
      this.$forceUpdate();
    },
  },
  methods: {
    golargescreen() {
      this.$router.push("/largescreen");
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/newhomepage/homemain.less";
</style>
